export default "__VITE_ASSET__ddce9abb__"